import React from 'react'

//starting with capital letter will ensure this is treated as a component
const InvGridItemPOD = ({formObject, viewData, rowKey}) => {

    return (
        <div className="saras-cell">
            <ul className="uiSearchSubList">
                {Object.values(viewData.childRows).map((row,index)=>(
                    <li>
                        <span className="sItemCode">{row.rowValues.itemCode.valF}</span>
                        <span className="sItemID">{row.rowValues.itemDetail.valF}</span>
                        <span className="sItemWeight">{row.rowValues.itemQty.valF}</span>
                        <span className="sItemCode uiCenter">{row.rowValues.itemQty2.valF}</span>
                    </li>
                ))
                }
            </ul>
        </div>
    );
}

export default InvGridItemPOD
